import React from "react";
import popupsyle from "../../style/PopUp.module.css";
import EditStyle from "../../style/Pages/EditPage.module.css";
import mainStyle from "../../style/Main.module.css";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import { useRef } from "react";
import { BsUpload } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import AddandEditStyle from "../../style/Pages/AddEditCompanyPage.module.css";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import Loader from "../../components/ui/Loader/Loader";
import { useEditCompany } from "../../hooks/useCompany";

const EditCompanyPage = ({ show, onClose, datas }) => {
  const fileInputRef = useRef(null);
  console.log(datas);
  const apiUrl = process.env.REACT_APP_API_URL;
  const {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    selectedImage,
    setSelectedImage,
    setFormData,
  } = useEditCompany(onClose);

  React.useEffect(() => {
    if (datas) {
      setFormData({
        id: datas.id,
        company_name: datas.company_name,
        company_email: datas.company_email,
        company_phone_num: datas.company_phone_num,
        company_address: datas.company_address,
        city: datas.city,
        state: datas.state,
        pincode: datas.pincode,
        company_logo: datas.company_logo,
      });
      if (datas?.company_logo) {
        setSelectedImage(`${apiUrl}${datas?.company_logo}`);
      }
    }
  }, [apiUrl, datas, setFormData, setSelectedImage]);
  const handleImageClick = () => {
    fileInputRef.current.click();
  };
  const handleDeleteImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    handleInputChange({
      target: { name: "company_logo", value: "" },
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;
    setSelectedImage(URL.createObjectURL(file));
    handleInputChange({
      target: {
        name: "company_logo",
        value: file,
      },
    });
  };

  const handleClose = () => {
    onClose();
  };
  if (!show) return null;

  return (
    <div className={popupsyle.popupBackground}>
      <div className={EditStyle.editPopupContainer}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>Edit Company</h3>
            {/* <TfiClose
              onClick={onClose}
              size={20}
              className={popupsyle.closePopup}
            /> */}
          </div>
          <div className={popupsyle.popupContent}>
            <div className={mainStyle.mainContentFormSplit}>
              <div className={mainStyle.mainInputDiv}>
                <label htmlFor="text" className={PageInputStyle.label}>
                  Company<span className={mainStyle.mantitory}>*</span>
                </label>
                <div className={AddandEditStyle.companyCardView}>
                  <div className={AddandEditStyle.companyCardViewsb}>
                    <div
                      className={AddandEditStyle.companyCardViewImage}
                      onClick={handleImageClick}
                    >
                      {selectedImage ? (
                        <img src={selectedImage} alt="img" />
                      ) : (
                        <div className={AddandEditStyle.uploadImageDiv}>
                          <BsUpload />
                          Upload Your Organization Logo
                        </div>
                      )}
                    </div>

                    <input
                      alt="Img"
                      type="file"
                      accept="image/*"
                      name="company_logo"
                      onChange={handleImageUpload}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                    <div className={AddandEditStyle.companyCardViewDelete}>
                      <RiDeleteBinLine
                        className={`${
                          AddandEditStyle.companyCardViewDeleteIcn
                        } ${
                          !selectedImage
                            ? AddandEditStyle.disabledDeleteIcon
                            : ""
                        }`}
                        onClick={selectedImage ? handleDeleteImage : null}
                      />
                    </div>
                  </div>
                </div>
                {error.company_logo && (
                  <span className={mainStyle.errorMsg}>
                    {error.company_logo}
                  </span>
                )}
              </div>

              <div></div>
            </div>
            <div className={mainStyle.mainContentFormSplit}>
              <PageInputField
                label="Company Name"
                name="company_name"
                placeholder="e.g., company name"
                required
                value={formData.company_name || ""}
                onChange={handleInputChange}
                error={error.company_name}
              />
              <PageInputField
                label="Company Email"
                name="company_email"
                placeholder="e.g., company@example.com"
                required
                value={formData.company_email || ""}
                onChange={handleInputChange}
                error={error.company_email}
              />
            </div>
            <div className={mainStyle.mainContentFormSplit}>
              <PageInputField
                label="Company Phone"
                name="company_phone_num"
                placeholder="e.g., 876543210"
                required
                value={formData.company_phone_num || ""}
                onChange={handleInputChange}
                error={error.company_phone_num}
              />
              <div className={mainStyle.mainInputDiv}>
                <label htmlFor="text" className={PageInputStyle.label}>
                  Address<span className={mainStyle.mantitory}>*</span>
                </label>
                <textarea
                  className={PageInputStyle.input}
                  name="company_address"
                  placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                  value={formData.company_address || ""}
                  onChange={handleInputChange}
                />
                {error.company_address && (
                  <span className={mainStyle.errorMsg}>
                    {error.company_address}
                  </span>
                )}
              </div>
            </div>
            <div className={mainStyle.mainContentFormSplit}>
              <PageInputField
                label="City"
                name="city"
                placeholder="e.g., Enter city "
                required
                value={formData.city || ""}
                onChange={handleInputChange}
                error={error.city}
              />
              <PageInputField
                label="State"
                name="state"
                placeholder="e.g., Enter state  "
                required
                value={formData.state || ""}
                onChange={handleInputChange}
                error={error.state}
              />
              <PageInputField
                label="Pincode"
                name="pincode"
                placeholder="e.g., Enter pincode"
                required
                value={formData.pincode || ""}
                onChange={handleInputChange}
                error={error.pincode}
              />
            </div>
          </div>
          <div className={popupsyle.popupButtonDiv}>
            <div className={popupsyle.actionButtons}>
              <button className={popupsyle.cancelButton} onClick={handleClose}>
                Cancel
              </button>
              <button
                className={popupsyle.updateButton}
                onClick={handleSubmit}
                // disabled={loader}
              >
                {loading ? <Loader /> : "Update"}
                {/* {loader ? (
                  <div className={styles.spinner}></div>
                ) : (
                  "Delete Logs"
                )} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCompanyPage;
